import { useMemo } from "react";

export const useMealUnpaid = (map) => {
	return useMemo(() => {
		if (!map) {
			return;
		}

		return map["MEALU"];
	}, [map]);
};
